var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter",on:{"click":_vm.like}},[(_vm.proxyPost.liked)?_c('div',{staticClass:"liked"}):_c('HeartIcon'),_vm._v("   "+_vm._s(_vm.$formatNum(_vm.proxyPost.likeCount))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }